<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="55"
    height="54"
    viewBox="0 0 55 54"
    fill="none"
  >
    <rect opacity="0.0661" width="55" height="53.1484" rx="6" fill="#213e7a" />
    <g clip-path="url(#clip0_4295_32092)">
      <path
        d="M32.5422 20.0781H22.4589C21.5307 20.0781 20.7783 20.8052 20.7783 21.7021V31.446C20.7783 32.3429 21.5307 33.07 22.4589 33.07H32.5422C33.4704 33.07 34.2228 32.3429 34.2228 31.446V21.7021C34.2228 20.8052 33.4704 20.0781 32.5422 20.0781Z"
        stroke="#213e7a"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M30.0212 24.1387H24.9795V29.0106H30.0212V24.1387Z"
        stroke="#213e7a"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.9795 17.6426V20.0785"
        stroke="#213e7a"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M30.0215 17.6426V20.0785"
        stroke="#213e7a"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.9795 33.0703V35.5063"
        stroke="#213e7a"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M30.0215 33.0703V35.5063"
        stroke="#213e7a"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M34.2227 24.1387H36.7435"
        stroke="#213e7a"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M34.2227 28.1973H36.7435"
        stroke="#213e7a"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.2568 24.1387H20.7777"
        stroke="#213e7a"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.2568 28.1973H20.7777"
        stroke="#213e7a"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4295_32092">
        <rect
          width="20.1667"
          height="19.4878"
          fill="white"
          transform="translate(17.417 16.8301)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default { name: "IconDeviceDispatch" };
</script>

<style></style>
